import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from 'lib/utils';
import * as S from './styles';
import { useAuth } from 'hooks/auth';

type Route = {
  title: string;
  path: string;
  blockedRoles?: string[];
};

const ROUTES: Route[] = [
  {
    title: 'Produtos bloqueados',
    path: '/inspecao-estoque/produtos-bloqueados',
  },
  {
    title: 'Produtos redirecionados',
    path: '/inspecao-estoque/produtos-redirecionados',
  },
  {
    title: 'Produtos priorizados',
    path: '/inspecao-estoque/produtos-priorizados',
  },
  {
    title: 'Ordens de serviço',
    path: '/inspecao-estoque/ordens-servico',
  },
  {
    title: 'Importar planilhas',
    path: '/inspecao-estoque/importar-planilhas',
    blockedRoles: ['warehouseMember', 'planner'],
  },
  {
    title: 'Métricas',
    path: '/dashboard#metrics',
  },
];

export const TabbedNavigation = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const location = useLocation();
  const { profile } = useAuth();

  const isRouteActive = React.useCallback(
    (path: string) => {
      if (path.includes('#')) {
        const [pathname, hash] = path.split('#');
        return location.pathname === pathname && location.hash === `#${hash}`;
      }

      return location.pathname === path;
    },
    [location.pathname, location.hash]
  );

  return (
    <div {...props} className={cn('flex flex-col w-full mb-6', className)}>
      <S.Container>
        {ROUTES.map(
          (route) =>
            !route.blockedRoles?.includes(profile?.type || '') && (
              <S.Button
                key={route.path}
                to={route.path}
                className={isRouteActive(route.path) ? 'active' : ''}
              >
                {route.title}
              </S.Button>
            )
        )}
      </S.Container>
    </div>
  );
};
